import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "unsupported-elements"
    }}>{`Unsupported Elements`}</h1>
    <p>{`Only elements found in the surrounding documentation are supported. Unsupported elements such as `}<inlineCode parentName="p">{`<li>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<ul>`}</inlineCode>{`, etc., are treated as simple `}<inlineCode parentName="p">{`<div>`}</inlineCode>{`s. As such, this does mean that you can often style unsupported elements in a way that more closely matches their browser counterparts.`}</p>
    <h2 {...{
      "id": "typography"
    }}>{`Typography`}</h2>
    <p>{`Several tags such as `}<inlineCode parentName="p">{`<i>`}</inlineCode>{` are not supported. However, you can easily add some CSS in order to support their visual appearance:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`i, em { font-style: italic; }
strong { font-weight: bold; }
q:before { content: '“'; }
q:after { content: '”'; }
blockquote { margin: 1em; }
pre { white-space: pre; }
code { font-family: Courier; }
`}</code></pre>
    <h2 {...{
      "id": "unordered-lists"
    }}>{`Unordered Lists`}</h2>
    <p>{`UXP does not, by default, support lists or list items. However, you can simulate an unordered list with bullets with some simple CSS.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`ul {
    margin-left: 1em;
}
li:before {
    content: '•';
    display: inline-block;
    text-align: center;
    margin-left: -1em;
    width: 1em;
}
`}</code></pre>
    <h2 {...{
      "id": "ordered-lists"
    }}>{`Ordered Lists`}</h2>
    <p>{`UXP does not support ordered lists (`}<inlineCode parentName="p">{`<ol>`}</inlineCode>{`). You can work around this by manually creating the numbered elements for each item.`}</p>
    <h2 {...{
      "id": "title"
    }}>{`Title`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<title>`}</inlineCode>{` element is not used in UXP. If you do specify it, you may find that it makes itself visible inside your plugin. To remedy this, add the following CSS to your project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`title {
    display: none;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      